import { Form, Input } from "decorator-form";
import InputType from "common/form/InputType";

@Form({ title: "Wrapper Div View Config" })
export default class WrapperDivConfig {

	@Input({ type: InputType.MARGIN, title: "Margin" })
	public margin?: string;

	@Input({ type: InputType.PADDING, title: "Padding" })
	public padding?: string;

}



// WEBPACK FOOTER //
// ./src/common/views/wrapperDiv/WrapperDivConfig.ts